import { MaalerAflaesning } from "../model/maaler-aflaesning.model";
import { MaalerType } from "../model/maaler-type.model";

export function findMaalerType(maalerAflaesning: MaalerAflaesning, maalerTyper: MaalerType[]): MaalerType {
    // Vi finder den målertype, som er angivet på måleraflæsningen
    const maalerType = maalerTyper.find(t => t.id === maalerAflaesning.maalerTypeId.aktuel);
    // Vi medtager kun de tællerværker, som skal være synlige for forbrugeren
    const enhedTyper = maalerAflaesning.taellevaerker.map(ta => ta.enhedType);
    const taellevaerker = maalerType.taellevaerker.filter(tv => enhedTyper.includes(tv.enhedType));
    return { ...maalerType, taellevaerker };
}
